import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../Personal Attendance/useAuth";

// ---------------------------------------------------------------------------
// src/pages/KPI/PlanningRouteGuard.js
//
// Route guard for Planning reports (Summary OTD, Blown-Up OTD). PURE PERMISSION
// model: access requires the "KPI - Planning Reports" permission. Only IT Admin
// bypasses. Role/identity flags (manager, super-user) no longer grant access on
// their own — no KPI permission means no report. Backend API remains [Authorize]d.
// ---------------------------------------------------------------------------

const PlanningRouteGuard = ({ children }) => {
    const auth = useAuth();

    const allowed =
        auth.isItAdmin ||
        (typeof auth.hasAccess === "function" && auth.hasAccess("KPI - Planning Reports"));

    if (!allowed) return <Navigate to="/access-denied" replace />;
    return <>{children}</>;
};

export default PlanningRouteGuard;
